import { call, query } from "../calls";

export const IssueLifeCycle = {
    search: (q) => query(`SELECT name, id FROM IssueLifeCycle WHERE name like '${q}'`),
    getById: (id) => query(`select * from IssueLifeCycle where id= ${id}`),
    getAll: () => query("SELECT id,name,dateFormat(toDate(creationDate), 'dd/MM/yyyy') as creationDate FROM IssueLifeCycle"),
    delete: (id) => call(`/IssueLifeCycle/${id}`, "DELETE"),
    getIssuesLifecycle: (q) => query(`SELECT title, id, nanoId FROM Issue WHERE lifeCycle = ${q}`),
    create: (body) => call("/IssueLifeCycle", "POST", body)
}